import styled from 'styled-components';
import { AllieButton } from '../../../../components';
import { AllieEyeIcon, AllieLogInOutlineIcon } from '../../../../styling/icons';

export const StyledAllieButton = styled(AllieButton)<{ isMobile?: boolean }>`
  --background: ${({ isMobile }) => (
    isMobile ? 'var(--allie-color-primary-main)' : 'var(--allie-color-secondary-90)')};
  --padding-end: var(--allie-spacing-md);
  --padding-start: var(--allie-spacing-md);
  --padding-bottom: var(--allie-spacing-sm);
  --padding-top: var(--allie-spacing-sm);
  margin: 0;

  @media (max-width: 576px) {
    --padding-end: var(--allie-spacing-sm);
    --padding-start: ${({ isMobile }) => (isMobile ? '2px' : 'var(--allie-spacing-sm)')};
  }
`;

export const StyledLoginIcon = styled(AllieLogInOutlineIcon)`
  font-size: 22px;
  background-color: var(--allie-color-secondary-main);
  border-radius: 100%;
  padding: 5px;
`;

export const StyledButtonContent = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: center;
  column-gap: ${({ isMobile }) =>
    isMobile ? 'var(--allie-spacing-xs)' : 'var(--allie-spacing-lg)'};
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const StyledAllieEyeIcon = styled(AllieEyeIcon)`
  background: transparent;
  border-radius: 100%;
  padding: 4px;
  font-size: 22px;
`;
